<template>
	<div
		class="resize-handle"
		:class="{ dragging: isDragging }"
		@pointerdown="(e) => onPointerDown(e, currentWidth)"
		@dblclick="resetToDefault"
	>
		<div class="resize-handle-bar" />
	</div>
</template>

<script>
import { useResizeHandle } from '@/composables/useResizeHandle'

export default {
	name: 'ResizeHandle',
	props: {
		currentWidth: { type: Number, required: true },
		maxWidth: { type: Number, required: true },
	},
	emits: ['resize', 'resize-end'],
	setup(props, { emit }) {
		const { isDragging, onPointerDown, resetToDefault } = useResizeHandle({
			onResize: (width) => emit('resize', width),
			onResizeEnd: () => emit('resize-end'),
			maxWidth: () => props.maxWidth,
		})

		return { isDragging, onPointerDown, resetToDefault }
	},
}
</script>

<style lang="scss" scoped>
.resize-handle {
	grid-column: 3;
	grid-row: 1 / -1;
	justify-self: start;
	width: 8px;
	cursor: col-resize;
	position: relative;
	z-index: 10;

	&::before {
		content: '';
		position: absolute;
		top: 0;
		bottom: 0;
		left: -4px;
		right: -4px;
	}

	.resize-handle-bar {
		width: 4px;
		height: 48px;
		border-radius: 2px;
		background: var(--neutral-300);
		opacity: 0;
		transition: opacity 0.15s ease;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
	}

	&:hover .resize-handle-bar,
	&.dragging .resize-handle-bar {
		opacity: 1;
	}
}
</style>
